import axios from "axios";

export default {
  methods: {
    async searchCep(cepWithMask) {
      return new Promise(async (resolve, reject) => {
        let address = {
          street: "",
          neighborhood: "",
          city: "",
          state: "",
          ibge: "",
        };
        let cep = cepWithMask.replace(/\D/g, "");
        const originalCep = cep;
        let foundCep = false;

        await viacepApi(cep)
          .then((result) => {
            foundCep = !!result;
          })
          .then(async () => {
            if (foundCep) resolve(address);
            else {
              await viacepApi(++cep).then((result) => {
                if (result) resolve(address);
                else reject("deu ruim");
              });
            }
          });

        async function viacepApi(cep) {
          let cep_8 = cep.toString().padStart(8, "0");
          return axios
            .get(`https://viacep.com.br/ws/${cep_8}/json/`, {
              withCredentials: false,
              transformRequest: (data, headers) => {
                delete headers.common["X-XSRF-TOKEN"];
                delete headers.common["X-Requested-With"];
                return data;
              },
            })
            .then(async (response) => {
              if (response.data["erro"]) {
                await cepawesomeApi(cep);
              } else {
                if (cep === originalCep) {
                  address.street =
                    response.data.logradouro.length > 60
                      ? response.data.logradouro.substring(0, 60)
                      : response.data.logradouro;
                  address.neighborhood =
                    response.data.bairro.length > 60
                      ? response.data.bairro.substring(0, 60)
                      : response.data.bairro;
                } else {
                  address.street = "";
                  address.neighborhood = "";
                }
                address.city =
                  response.data.localidade.length > 60
                    ? response.data.localidade.substring(0, 60)
                    : response.data.localidade;
                address.state =
                  response.data.uf.length > 60
                    ? response.data.uf.substring(0, 60)
                    : response.data.uf;
                address.ibge = response.data.ibge;
              }
            })
            .then((response) => {
              return true;
            })
            .catch((error) => {
              return error;
            });
        }

        async function cepawesomeApi(cep) {
          let cep_8 = cep.toString().padStart(8, "0");
          return axios
            .get(`https://cep.awesomeapi.com.br/json/${cep_8}`, {
              withCredentials: false,
              transformRequest: (data, headers) => {
                delete headers.common["X-XSRF-TOKEN"];
                delete headers.common["X-Requested-With"];
                return data;
              },
            })
            .then((response) => {
              if (isEmpty(response.data)) {
                return false;
              } else {
                if (cep === originalCep) {
                  address.street =
                    response.data.address.length > 60
                      ? response.data.address.substring(0, 60)
                      : response.data.address;
                  address.neighborhood =
                    response.data.neighborhood.length > 60
                      ? response.data.neighborhood.substring(0, 60)
                      : response.data.neighborhood;
                } else {
                  address.street = "";
                  address.neighborhood = "";
                }
                address.city =
                  response.data.city.length > 60
                    ? response.data.city.substring(0, 60)
                    : response.data.city;
                address.state =
                  response.data.state.length > 60
                    ? response.data.state.substring(0, 60)
                    : response.data.state;
                address.ibge = response.data.city_ibge;
              }
            })
            .then((response) => {
              return true;
            })
            .catch((error) => {
              return error;
            });
        }
      });
    },
    ceilDecimals(n, decimals = 2) {
      if (n < 0) {
        let positiveN = n * -1;
        return this.floorDecimals(positiveN, decimals);
      }

      let powerValue = 10 ** decimals;
      n *= powerValue;
      let modValue = n % 1;

      if (modValue >= 0.1) n = Math.floor(n) + 1;
      else n = Math.floor(n);

      n = n / powerValue;
      return n;
    },

    floorDecimals(n, decimals = 2) {
      let powerValue = 10 ** decimals;
      return Math.floor(n * powerValue) / powerValue;
    },
  },
};
